import { createContext, useContext, useEffect, useState } from "react";
import { useFilterContext } from "../../../hooks/FilterContext";
import { useLazyAgedDebtorsQuery } from "../../../services/headofficeadmin";

const GetAgedDebtorsContext = createContext();

export const useGetAgedDebtors = () => useContext(GetAgedDebtorsContext);

const GetAgedDebtorsProvider = ({ children }) => {

    const { filter } = useFilterContext();
    const [isClearing, setIsClearing] = useState(false);
    //const [sort, setSort] = useState("feeDate+ASC");
    const [searchTrigger, searchResults] = useLazyAgedDebtorsQuery();
    const { data, isLoading, isFetching, isError, error, isUninitialized } = searchResults;
    //const { results  } = data || { results: [] };
    const results = data || [];

    //console.log('agedDebtorHookFilters',filter);
    //console.log('hook searchTrigger',searchTrigger);
    //console.log('hook searchResults ',searchResults, 'hook data', data, 'hook results', results );

    const clear = () => {
        setIsClearing(true);
        searchTrigger({
            filter:{...filter
                //feeTypes: filter.feeTypes?.map(x => x.value) ?? []
                }
        }).finally(() => setIsClearing(false));
    };
    const isItemLoaded = (index) => index < results.length || results[index];

    const retryGetAgedDebtors = (e) => {
        if (e && typeof (e) === "function") {
            e.preventDefault();
        }

        clear();
    };

    useEffect(() => {
        //if (isUninitialized) return;// always seems to be even when data returned 
        clear();
    }, [filter]); //[sort, filter]);

    //console.log('aged debtor date from hook', results);

    return <GetAgedDebtorsContext.Provider value={{
        results: results || [],
        isClearing,
        isLoading,
        isFetching,
        error,
        isError,
        isItemLoaded,
        retryGetAgedDebtors
    }}>
        {children}
    </GetAgedDebtorsContext.Provider>


};

export default GetAgedDebtorsProvider;